"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOperatorFromSelector = exports.makeMySqlWherePart = exports.SqlWherePartType = void 0;
const mysql_1 = require("mysql");
const Operator_1 = require("./Operator");
var SqlWherePartType;
(function (SqlWherePartType) {
    SqlWherePartType[SqlWherePartType["POSITIVE_WHOLE_NUMBER"] = 0] = "POSITIVE_WHOLE_NUMBER";
    SqlWherePartType[SqlWherePartType["STRING"] = 1] = "STRING";
    SqlWherePartType[SqlWherePartType["TIMESTAMP"] = 2] = "TIMESTAMP";
    SqlWherePartType[SqlWherePartType["BOOLEAN"] = 3] = "BOOLEAN";
})(SqlWherePartType = exports.SqlWherePartType || (exports.SqlWherePartType = {}));
function makeMySqlWherePart(valueField, type, selector, valueFormatter) {
    if (selector === undefined) {
        return "";
    }
    const operator = getOperatorFromSelector(selector);
    let criterions;
    if (operator === undefined) {
        throw new Error("Invalid operator.");
    }
    if (Array.isArray(selector[operator])) {
        criterions = [...selector[operator]];
    }
    else {
        criterions = [selector[operator]];
    }
    if (criterions.length < 1 ||
        criterions[0] === undefined ||
        criterions[0] === null ||
        (typeof criterions[0] === "string" &&
            criterions[0].length === 0)) {
        throw new Error("Criteria is required.");
    }
    const sqlOperator = toSqlOperator(operator);
    if (valueFormatter) {
        criterions = criterions.map((criterion) => (valueFormatter(criterion)));
    }
    if (operator === Operator_1.Operator.CONTAINING ||
        operator === Operator_1.Operator.NOT_CONTAINING ||
        operator === Operator_1.Operator.ENDING_WITH ||
        operator === Operator_1.Operator.NOT_ENDING_WITH) {
        criterions[0] = `%${criterions[0]}`;
    }
    if (operator === Operator_1.Operator.CONTAINING ||
        operator === Operator_1.Operator.NOT_CONTAINING ||
        operator === Operator_1.Operator.BEGINNING_WITH ||
        operator === Operator_1.Operator.NOT_BEGINNING_WITH) {
        criterions[0] = `${criterions[0]}%`;
    }
    if (operator === Operator_1.Operator.BETWEEN) {
        if (criterions.length < 2 ||
            criterions[1] === undefined ||
            criterions[1] === null ||
            (typeof criterions[1] === "string" &&
                criterions[1].length === 0)) {
            throw new Error("More than one criteria is required.");
        }
        return `${valueField} ${sqlOperator} ` +
            `${mysql_1.escape(criterions[0])} AND ${mysql_1.escape(criterions[1])}`;
    }
    else if (operator === Operator_1.Operator.IN) {
        return `${valueField} ${sqlOperator} (` + mysql_1.escape(criterions) + ")";
    }
    else {
        return `${valueField} ${sqlOperator} ${mysql_1.escape(criterions[0])}`;
    }
}
exports.makeMySqlWherePart = makeMySqlWherePart;
function getOperatorFromSelector(selectorOperatorType) {
    for (const key of Object.keys(selectorOperatorType)) {
        return key;
    }
    return;
}
exports.getOperatorFromSelector = getOperatorFromSelector;
function toSqlOperator(valueOperator) {
    switch (valueOperator) {
        case Operator_1.Operator.EQUALS_TO:
            return "=";
        case Operator_1.Operator.GREATER_THAN:
            return ">";
        case Operator_1.Operator.LESS_THAN:
            return "<";
        case Operator_1.Operator.GREATER_THAN_OR_EQUALS_TO:
            return ">=";
        case Operator_1.Operator.LESS_THAN_OR_EQUALS_TO:
            return "<=";
        case Operator_1.Operator.NOT_EQUALS_TO:
            return "<>";
        case Operator_1.Operator.CONTAINING:
        case Operator_1.Operator.BEGINNING_WITH:
        case Operator_1.Operator.ENDING_WITH:
            return "LIKE";
        case Operator_1.Operator.NOT_CONTAINING:
        case Operator_1.Operator.NOT_BEGINNING_WITH:
        case Operator_1.Operator.NOT_ENDING_WITH:
            return "NOT LIKE";
        case Operator_1.Operator.IN:
            return "IN";
        case Operator_1.Operator.BETWEEN:
            return "BETWEEN";
        default:
            return "";
    }
}
//# sourceMappingURL=dbUtilities.js.map